import PricesList from "../List/List";

const PricesNavigation = {
    init() {
        this.el = $('[page="prices"] [block="nav"]');
        if (!this.el.length) return;

        this.links = this.el.find("a");
        this.bind();
    },

    bind() {
        this.links.on("click", (evt) => {
            event.preventDefault();
            const el = $(evt.currentTarget);
            const newUrl = el.attr("href");
            const categoryID = el.attr("category");

            el.addClass('active').siblings().removeClass('active');
            history.pushState(null, null, newUrl);
            PricesList.setActiveList(categoryID);
        });
    }
}
export default PricesNavigation;